import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

interface Props {
  status: 'Active' | 'Draft';
  backgroundColor: string;
}

const Status: React.FC<Props> = ({ status, backgroundColor }) => {
  return (
    <span
      className={clsx(
        'mx-auto text-center w-14 rounded px-2 py-1 text-sm text-white',
        backgroundColor,
      )}
      data-intercom-target={
        status === 'Active' ? 'published-collection-status' : 'draft-collection-status'
      }
    >
      <T kind={status} />
    </span>
  );
};

export default observer(Status);
